<template>
  <div>
    <div style="margin-bottom: 20px;">
      <p >注意:上传文件中，不要放置宏或图标，不要更改列的顺序，数据中不要使用公式。。</p>
      <a @click="downloadModel">(下载模板)</a>
    </div>
    
    <!--  远古问题： file控件 对于重复选择同样的文件不会触发change事件 导致如果要在选文件的时候做load效果 退出的时机不好控制
          因此用 button按钮 + 文本显示文件名 模拟显示效果 隐藏一个file控件做实际文件选择 达成在选文件的时候显示load 
    -->
    <button @click="fileClick" >选择文件</button>  {{fileName}}
    <input ref="fileInput" type="file" @change="fileChange" style="display: none"/>
    <button @click="uploadFile" style="float: right;">确认上传</button>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
 
<script>
import axios from 'axios'
import StrUtil from '@/common/js/util'

export default {
  name: "FormExcelUpload",
  data() {
    return {
      fileName: "未选择文件",
      spinShow: false,
      selectedFile: null,
      tableName: null,
      tableId: null,
      itemId: null,
      userId: null
    };
  },
  created() {
    const { tableName, tableId, itemId } = this.$router.currentRoute.params;
    this.tableName = tableName;
    this.tableId = tableId;
    this.itemId = itemId;
    this.userId = this.$store.state.global.userInfo.id;
  },
  methods: {
    fileClick(event) {
      //this.spinShow = true;
      this.$refs.fileInput.click();
    },
    downloadModel() {
      axios({
        url: "/p/cs/scrm/getDownloadFileUrl",
        method: "POST",
        data: {}
      }).then(({ data }) => {
        if (data.data.code == 0) {
          window.location.href = data.data.url;
        }else {
          this.$Message.error(data.data.message);
        }
      });
    },
    fileChange(event) {
      this.spinShow = true;
      this.selectedFile = event.target.files[0];
      this.fileName = this.selectedFile.name;
      this.$refs.fileInput.value = '';
      this.spinShow = false;
    },
    checkFile() {
      let file = this.selectedFile;
      if (file == null) {
      	this.$Message.error("请正确选择文件！");
      	return;
      }
      let fileName = file.name;
      let fileExt = StrUtil.getFileExt(fileName);
      let isErrFile = true;
      if ('xlsx' === fileExt || 'xls' === fileExt) {
        isErrFile = false;
      }
      if (isErrFile) {
        this.$Message.error("请正确选择EXCEL文件！");
        return;
      }
      // 文件大于 10MB
      if (file.size > 10485760) {
        this.$Message.error("选择的文件过大(大于10M)，请减少多余内容后再上传！");
        return;
      }
      return true;
    },
    uploadFile() {
      this.spinShow = true;
      if (this.checkFile() != true) {
        this.spinShow = false;
        return;
      }
      
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('objId', this.itemId == 'New' ? -1 : this.itemId);
      formData.append('tableName', this.tableName);
      formData.append('tableId', this.tableId);
      formData.append('userId', this.userId);
 
      axios.post('/p/cs/formImport', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        console.log(res);
        this.spinShow = false;
        let resData = res.data || {};
        if (resData.code == 0) {
          this.$Modal.fcSuccess({
              title: '成功',
              content: resData.message
          });
          this.$emit('closeActionDialog', true);
          document.querySelector('#refresh').click()
        } else {
          this.$Modal.fcError({
            title: '失败',
            content: resData.message
          });
        }
      }).catch(error => {
        this.spinShow = false;
        this.$Modal.fcError({
            title: '异常',
            content: error
          });
        console.error(error);
      });
    }
  }
};
</script>